var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),(_vm.isLoading)?_c('PreLoader'):_vm._e(),_c('router-view'),(_vm.currentUrl == '/not-found' || _vm.currentUrl == '/coming-soon')?_c('div'):_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }